import { Badge } from "@/components/ui/badge";
import { Crown, ShieldCheck, Star, Clapperboard, Mic } from "lucide-react";

const ROLE_CLASS = {
  owner: "border-transparent bg-[#C9772E] text-white",
  admin: "border border-[rgba(201,119,46,0.45)] bg-[rgba(201,119,46,0.22)] text-[#8A4A18]",
  core: "border border-primary/35 bg-primary/10 text-primary",
  producer: "border border-teal-300 bg-teal-50 text-teal-800",
  podcast: "border border-[rgba(201,119,46,0.4)] bg-[rgba(201,119,46,0.12)] text-[#8A4A18]",
};

const ROLE_ICON = {
  owner: Crown,
  admin: ShieldCheck,
  core: Star,
  producer: Clapperboard,
  podcast: Mic,
};

const ROLE_LABEL = {
  owner: "Owner",
  admin: "Admin",
  core: "Core",
  producer: "Producer",
  podcast: "Podcast",
};

export function getRoleBadgeKeys({ roles = [], is_owner = false, podcast_eligible = false } = {}) {
  const keys = [];
  // "Owner" is shown as Admin in the UI (the protected-owner logic stays server-side).
  if (is_owner || roles.includes("admin")) keys.push("admin");
  if (roles.includes("core")) keys.push("core");
  if (roles.includes("producer")) keys.push("producer");
  if (podcast_eligible) keys.push("podcast");
  return keys;
}

export function RoleBadges({
  roles = [],
  is_owner = false,
  podcast_eligible = false,
  showEligible = true,
  showMember = false,
  size = "default",
  className = "",
}) {
  let keys = getRoleBadgeKeys({ roles, is_owner, podcast_eligible });
  if (!showEligible) keys = keys.filter((k) => k !== "podcast");

  const sizeClass = size === "sm" ? "px-1.5 py-0 text-[10px]" : "";
  const iconClass = size === "sm" ? "mr-0.5 h-2.5 w-2.5" : "mr-1 h-3 w-3";

  if (keys.length === 0) {
    if (showMember) {
      return (
        <Badge variant="secondary" className={`${sizeClass} ${className}`} data-testid="role-badge-member">
          Member
        </Badge>
      );
    }
    return null;
  }

  return (
    <span className={`inline-flex flex-wrap items-center gap-1.5 ${className}`}>
      {keys.map((k) => {
        const Icon = ROLE_ICON[k];
        return (
          <Badge key={k} className={`${ROLE_CLASS[k]} ${sizeClass}`} data-testid={`role-badge-${k}`}>
            <Icon className={iconClass} />
            {ROLE_LABEL[k]}
          </Badge>
        );
      })}
    </span>
  );
}
